/**
 * Returns true when the given date falls on a specific month and day,
 * ignoring the year. Useful for annual events / easter eggs.
 *
 * The comparison uses the local-time getters (getMonth/getDate), so it is
 * evaluated in the user's own timezone. In the browser this means a user in
 * Tokyo flips on April 1st JST while a user in New York flips on April 1st EDT.
 * Do not switch these to the getUTC* variants unless you specifically want a
 * single global UTC-based rollover instead of per-user local dates.
 *
 * @param month 1-indexed month (1 = January, 12 = December)
 * @param day   day of the month (1-31)
 * @param date  the date to test; defaults to the current date
 */
export const isSpecificDate = (
  month: number,
  day: number,
  date: Date = new Date(),
): boolean => {
  // getMonth() is 0-indexed, so convert the 1-indexed month argument.
  return date.getMonth() === month - 1 && date.getDate() === day;
};
